import(/* webpackMode: "eager" */ "/opt/buildhome/repo/web/src/app/page.tsx");
